import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { CreateTaskDialogComponent } from '../create-task-dialog/create-task-dialog.component';
import { EDialogWidth } from 'projects/shared/src/lib/core/enums';
import {
  ActionItemInterface,
  DialogConfigInterface,
  TaskItemInterface,
} from 'projects/shared/src/lib/core/interfaces';
import { TasksService } from 'projects/shared/src/lib/core/services/tasks.service';
import { ToastrAbstractionService } from 'projects/shared/src/lib/core/services/toastr-abstraction.service';

@Component({
    selector: 'app-view-all-task-dialog',
    templateUrl: './view-all-task-dialog.component.html',
    styleUrls: ['./view-all-task-dialog.component.scss'],
    standalone: false
})
export class ViewAllTaskDialogComponent implements OnDestroy {
  private readonly _destroying$ = new Subject<void>();
  private _tasksPage = 1;
  public actions: ActionItemInterface[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogConfigInterface,
    public tasksService: TasksService,
    private _toastr: ToastrAbstractionService,
    private _translate: TranslateService,
    private _dialog: MatDialog,
  ) {}

  public viewTaskDetail(taskItem: TaskItemInterface): void {
    const dialogConfig: DialogConfigInterface = {
      title: `${this._translate.instant('DIALOG.TITLE.TASKS.TASK_DETAIL')}`,
      isCloseBtn: true,
      disableClose: false,
      data: taskItem,
    };

    this._dialog
      .open(CreateTaskDialogComponent, {
        data: dialogConfig,
        width: EDialogWidth.MEDIUM,
      })
      .afterClosed()
      .subscribe();
  }

  public scrollWindow(event: Event) {
    const container = event.target as HTMLElement;
    const atBottom =
      container.scrollHeight - container.scrollTop <=
      container.clientHeight + 100;
    if (atBottom && !this.tasksService.loading) {
      this._tasksPage++;
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
